import { useEffect, useState } from "react";

import { Box, Button, MantineProvider, Stack } from "@mantine/core";
import { useNavigate, useParams, Link } from "react-router-dom";
import ClientOnly from "~/../../base-components/lib/ClientOnly";
import { ArrowLeft } from "~/../../base-components/lib/assets/icons/HDS";
import { SECONDARY_COLOR } from "~/../../base-components/lib/theme/button";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "~/../../shared-features/lib/features/auth/hooks";
import { AppSEO } from "~/../../shared-features/lib/features/layout";

import { TOOLS_URL } from "config";

import { CurationBuilder } from "./builder/CurationBuilder";
import { Curation, useMockServer } from "./builder/_mock";

export const EditCuration = () => {
  const navigate = useNavigate();
  const { curationId } = useParams();
  const { getCuration, updateCuration } = useMockServer();
  const [curation, setCuration] = useState<Curation | null>(null);
  const enableCuratedSpacesPreview = useFeatureFlags(
    FEATURE_FLAGS.CURATED_SPACES_PREVIEW
  );

  useEffect(() => {
    const loadCuration = async () => {
      try {
        if (curationId == null) {
          throw new Error("Curation ID is required");
        }
        const curation = await getCuration(curationId);
        setCuration(curation);
      } catch (error) {
        console.error("Error loading curation", error);
        // navigate("/404");
      }
    };

    loadCuration();
  }, [curation, curationId, getCuration, navigate]);

  if (enableCuratedSpacesPreview === false) {
    return <Box>Curated Spaces are coming soon!</Box>;
  }

  if (curation == null) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <AppSEO title="Edit Curation" />

      <ClientOnly>
        <MantineProvider inherit withCSSVariables>
          {/* <Container size="sm" mb={116}>
              hi
            </Container> */}

          <Box
            sx={{
              height: "100dvh",
              maxHeight: "100dvh",
              minHeight: "100dvh",
              width: "100%",
              maxWidth: "100%",
              minWidth: "100%",
              "--var-builder-panel-color": "var(--mantine-color-white)",
            }}
          >
            <Stack h={"100%"} w={"100%"} spacing={0}>
              <Box h={56}>
                <Link to={TOOLS_URL.curations.list}>
                  <Button
                    color={SECONDARY_COLOR}
                    leftIcon={<ArrowLeft height={12} />}
                  >
                    Back
                  </Button>
                </Link>
              </Box>
              <Box h={"100%"} mah={"calc(100% - 56px)"}>
                <CurationBuilder
                  initialProjectData={curation.draft.projectData}
                  onSetHtml={(html) => {
                    console.log("html", html);
                  }}
                  onSave={async ({ css, html, data }) => {
                    console.log("Save", { css, html, data });
                    try {
                      await updateCuration(curation.id, {
                        ...curation,
                        draft: {
                          ...curation.draft,
                          css,
                          html,
                          projectData: data,
                        },
                      });
                      console.log("Saved");
                      alert("Saved!");
                    } catch (error) {
                      console.error("Error saving curation", error);
                    }
                  }}
                  onShowPreview={() => {
                    console.log("Show Preview");
                    window.open(
                      window.location.href.replace("/edit", "/preview"),
                      "_blank"
                    );
                  }}
                />
              </Box>
            </Stack>
          </Box>
        </MantineProvider>
      </ClientOnly>
      {/* </AppShell> */}
    </>
  );
};
